import React, {Fragment} from "react";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import NsDataTable from "../../components/tabelle/NsDataTable";
import ModalAnteprimaExport from "../kpi/rendicontazione/components/ModalAnteprimaExport";

export default function ExportKpiView({
                                          listaKpi,
                                          listaGrafici,
                                          translate,
                                          show,
                                          setShow,
                                          modalMsg,
                                          containerRef,
                                          showAnteprimaDoc,
                                          setShowAnteprimaDoc,
                                          fileAnteprima,
                                          onChangeGrafici,
                                          bottoniSx,
                                          bottoniDx,
                                          onChangeAllExport,
                                          onChangeExport,
                                      }) {

    return (
        <Card
            title={"Esportazione documento KPI"}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        >
            <ModalMsg
                show={show}
                handleClose={() => {
                    setShow(false);
                }}
                testo={modalMsg}/>
            <ModalAnteprimaExport
                containerRef={containerRef}
                show={showAnteprimaDoc}
                handleClose={() => setShowAnteprimaDoc(false)}
                handlerDownload={() => {
                    window.open(URL.createObjectURL(fileAnteprima));
                }}
            />
            <NsDataTable
                data={listaKpi}
                columns={[
                    {
                        name: translate('Codice'),
                        selector: row => row.codice,
                        sortable: true,
                    },
                    {
                        name: translate('Descrizione'),
                        selector: row => row.descrizione,
                        sortable: true,
                    },
                    {
                        name: translate('Macrocategoria'),
                        selector: row => row.kpi_macrocategoria,
                        sortable: true,
                    },
                    {
                        name: translate('Grafici'),
                        selector: row => {
                            let graficiKpi = listaGrafici && listaGrafici.filter(g => g.id_kpi == row.id_kpi);
                            if (graficiKpi.length > 0) {
                                return (
                                    <select
                                        className={"form-control form-select"}
                                        onChange={(e) => {
                                            onChangeGrafici(e, row);
                                        }}
                                    >
                                        <option value={""}>Nessun grafico</option>
                                        {
                                            graficiKpi.map(g => <option key={g.id_grafico_kpi}
                                                                        value={g.id_grafico_kpi}>{g.descrizione}</option>)
                                        }
                                    </select>
                                );
                            }
                        },
                        sortable: true,
                    },
                    {
                        name: <Fragment>
                            <input
                                type={"checkbox"}
                                name={"all_export"}
                                className={"form-contorl"}
                                onChange={onChangeAllExport}
                            />&nbsp;{translate('Export')}
                        </Fragment>,
                        selector: row => <input
                            type={"checkbox"}
                            name={'export_' + row.id_kpi}
                            id={'export_' + row.id_kpi}
                            className={"form-contorl"}
                            checked={row.export && row.export == '1'}
                            onChange={(e) => {
                                onChangeExport(e, row);
                            }}
                        />,
                        sortable: false,
                    }
                ]}
            />
        </Card>
    );
}